module.exports = __webpack_public_path__ + "img/u51.becc3224.png";